// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"366":"1d2671aa","806":"4163ae0c"}[chunkId] || chunkId) + "." + {"208":"c937ddf6772033fb","227":"157b39d97054e1f1","366":"5e5470f7562e5d0e","526":"56cd9784b8f6e708","806":"611492ddd6e516ab"}[chunkId] + ".js";
};